import React from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';

import DiagnoseImage from 'assets/images/pages/homepage/diagnose.png';
import DesignImage from 'assets/images/pages/homepage/design.png';
import EarnImage from 'assets/images/pages/homepage/earn.png';
import ShowcaseImage from 'assets/images/pages/homepage/showcase.png';
import BuildImage from 'assets/images/pages/homepage/build.png';
import ApplyImage from 'assets/images/pages/homepage/apply.png';

import Student1Image from 'assets/images/pages/homepage/student-1.png';
import Student2Image from 'assets/images/pages/homepage/student-2.png';
import Student3Image from 'assets/images/pages/homepage/student-3.png';
import Student4Image from 'assets/images/pages/homepage/student-4.png';
import Student5Image from 'assets/images/pages/homepage/student-5.png';
import Student6Image from 'assets/images/pages/homepage/student-6.png';

import Job1Image from 'assets/images/pages/homepage/job-1.png';
import Job2Image from 'assets/images/pages/homepage/job-2.png';

import { Airdrop, Book1, Briefcase, ProfileTick } from 'iconsax-react'; 
import classes from './RoadMap.module.scss';


const RoadMap = ({ type, position }) => {
    const roadmapData = {
        students: [
            {
                title: "Understand Pharma Careers Early",
                description: "Discover how the pharma industry works and what skills different roles expect.",
                image: <Airdrop size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Build Job-Relevant Skills",
                description: "Use courses and career paths to build practical skills beyond your academic studies.",
                image: <Book1 size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Create Your First Professional Profile",
                description: "Turn your learning progress, completed courses, and certificates into a shareable profile.",
                image: <ProfileTick size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Plan Your Next Step",
                description: "Use your Career Competency Radar and job insights to see what to learn next.",
                image: <Briefcase size="28" color="#18BBA8" variant="TwoTone" />
            }
        ],
        job_seekers: [
            {
                title: "Build Your Starting Point",
                description: "Create or upload your CV and turn it into a Career Competency Radar to understand your pharma job fit.",
                image: <Airdrop size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Follow a Job-Focused Path",
                description: "Use structured career paths and targeted courses to build the skills needed for the pharma role you want.",
                image: <Book1 size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Discover Better-Fit Roles",
                description: "Find pharma jobs aligned with your strengths, gaps, and Career Competency Radar.",
                image: <Briefcase size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Prepare to Apply",
                description: "Get resume, interview, and career coaching support so you can apply with more confidence.",
                image: <ProfileTick size="28" color="#18BBA8" variant="TwoTone" />
            }
        ],
        professionals: [
            {
                title: "Assess Your Readiness",
                description: "Upload your CV and get your Career Competency Radar to compare your skills with pharma market expectations.",
                image: <Airdrop size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Close the Right Gaps",
                description: "Use targeted courses and career paths to build the skills your next role requires.",
                image: <Book1 size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Match with Relevant Jobs",
                description: "Explore pharma jobs while your radar is matched with each role's competency radar.",
                image: <Briefcase size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Get Expert Guidance",
                description: "Access consultation, interview preparation, and career coaching to plan your next move with confidence.",
                image: <ProfileTick size="28" color="#18BBA8" variant="TwoTone" />
            }
        ],
        career_changers: [
            {
                title: "Map Your Transferable Skills",
                description: "Create or upload your CV and see how your current skills translate into pharma through your Career Competency Radar.",
                image: <Airdrop size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Build Pharma Foundations",
                description: "Use targeted courses and career paths to build the essential pharma knowledge your new direction requires.",
                image: <Book1 size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Create a Professional Pharma Profile",
                description: "Showcase your progress, completed courses, and certificates in a shareable professional profile.",
                image: <ProfileTick size="28" color="#18BBA8" variant="TwoTone" />
            },
            {
                title: "Explore Better-Fit Pharma Roles",
                description: "Find pharma roles that align with your skills, learning progress, and Career Competency Radar.",
                image: <Briefcase size="28" color="#18BBA8" variant="TwoTone" />
            }
        ]
    };

    const ctaData = {
        students: {
            label: "See What Pharmuni Offers for Student",
            to: "https://pharmuni.com/student/"
        },
        job_seekers: {
            label: "See What Pharmuni Offers for Job Seekers",
            to: "https://pharmuni.com/job-seeker/"
        },
        professionals: {
            label: "See What Pharmuni Offers for Professionals",
            to: "https://pharmuni.com/professional/"
        },
        career_changers: {
            label: "See What Pharmuni Offers for Career Changers",
            to: "https://pharmuni.com/career-changer/"
        }
    };

    return (
        <>
            <div className={`${classes.wrapper} ${classes[type]}`}>
                <div className={classes.item}>
                    <div className={classes.icon}>{roadmapData[type][0].image}</div>
                    <h3>{roadmapData[type][0].title}</h3>
                    <p>
                        {roadmapData[type][0].description}
                    </p>
                </div>
                <div className={classes.item}>
                    <div className={classes.icon}>{roadmapData[type][1].image}</div>
                    <h3>{roadmapData[type][1].title}</h3>
                    <p>
                        {roadmapData[type][1].description}
                    </p>
                </div>
                <div className={classes.item}>
                    <div className={classes.icon}>{roadmapData[type][2].image}</div>
                    <h3>{roadmapData[type][2].title}</h3>
                    <p>
                        {roadmapData[type][2].description}
                    </p>
                </div>
                <div className={classes.item}>
                    <div className={classes.icon}>{roadmapData[type][3].image}</div>
                    <h3>{roadmapData[type][3].title}</h3>
                    <p>
                        {roadmapData[type][3].description}
                    </p>
                </div>
            </div>
            <div className={`${classes['roadmap-footer']} `}>      

                <LinkButton kind='secondary-lecture' href={ctaData[type].to}>
                    {ctaData[type].label}
                </LinkButton>
            </div>
        </>
    );
};

export default RoadMap;